<template>
   <div class="journey mt-4 mx-2 d-flex flex-column align-items-end p-2">
      <div class="position-relative d-flex w-100 align-items-start">
         <ChoiceImage class="journey-image m-2" :choice="journey.customer" :max-height="65" />
         <div class="d-flex flex-column justify-content-start align-items-start mx-2">
            <p class="journey-name mt-2 m-0 font-weight-bold">
               {{ journey.customer.name }}
            </p>
            <div class="text-break text-left d-flex">
               <p class="m-0 mr-2">{{ name }}</p>
               <p v-for="language in journey.languages" :key="language.id" class="m-0 mr-2">{{ language.code }}</p>
            </div>
         </div>
         <div v-if="journey.id == previous_journey_id" class="journey-busy d-flex justify-content-center align-items-center">
            {{ $t('dashboard.busy') }}
         </div>
      </div>
      <button class="journey-button mt-auto" @click="openJourney(journey)">{{ $t('dashboard.questionnaire') }}</button>
   </div>
</template>

<script>
import RouterPush from '@/core/helpers/routerPush';
import ChoiceImage from '@/modules/journeys/components/question/choiceImage';
const routerPush = new RouterPush();

export default {
   components: {
      ChoiceImage,
   },

   props: {
      journey: Object,
   },

   data() {
      return {
         previous_journey_id: sessionStorage.getItem('journey_id'),
      };
   },

   created() {},

   mounted() {},

   computed: {
      name() {
         return this.journey.name[this.$i18n.locale];
      },
   },

   methods: {
      openJourney(journey) {
         routerPush.toJourney(journey);
      },
   },
};
</script>

<style lang="scss" scoped>
.journey {
   z-index: 1;
   @media (min-width: 769px) {
      width: 270px;
      min-height: 150px;
   }

   min-height: 120px;
   background-color: #fff;
   border-radius: 5px;
   box-shadow: 0 1px 0.5px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.2);
}

.journey-image {
   max-width: 65px;
   max-height: 65px;
}
.journey-button {
   width: 160px;
   cursor: pointer;
   // height: 36px;
   font-size: 0.9rem;
   padding: 7.5px 20px;
   color: white;
   background-color: #0cd0f0;
   background-color: var(--primaryColor);
   border: none;
   border-radius: 6px;
}

.journey-name {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.journey-busy {
   position: absolute;
   right: 0;
   background-color: #e99800;
   text-transform: uppercase;
   border-radius: 50px;
   font-size: 0.7rem;
   color: white;
   height: 18px;
   width: 90px;
}
</style>

